'use client'

import React from 'react'
import Section from './Section'
import styles from './styles.module.css'

function DownloadsPage(props) {
  return (
    <div className={styles.sections}>
      <div className={styles.sectionsContent}>
        <Section section={props} />
      </div>
    </div>
  )
}

export default DownloadsPage
